import styled from "styled-components";

export const Form = styled.form`
`;

export const Input = styled.input`
   padding: 20px 36px;
  border-radius: 60px;
  font-size: 18px;
  color:rgb(1, 34, 69);
  border: 3px solid rgb(0, 170, 255);
  outline: none;
`;
